import { render, staticRenderFns } from "./deviation.vue?vue&type=template&id=58b0f2d5&scoped=true"
import script from "./deviation.vue?vue&type=script&lang=js"
export * from "./deviation.vue?vue&type=script&lang=js"
import style0 from "./deviation.vue?vue&type=style&index=0&id=58b0f2d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b0f2d5",
  null
  
)

export default component.exports